import { keyframes } from 'styled-components';

export const fadeIn = keyframes`
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;

export const fadeOut = keyframes`
	from {
		opacity: 1;
	}
	to {
		opacity: 0;
	}
`;

export const slideUp = keyframes`
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

export const slideDown = keyframes`
	from {
		opacity: 0;
		transform: translateY(-20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

export const expandCarousel = keyframes`
	from {
		max-height: 0;
		opacity: 0;
	}
	to {
		max-height: 300px;
		opacity: 1;
	}
`;

export const collapseCarousel = keyframes`
	from {
		max-height: 300px;
		opacity: 1;
	}
	to {
		max-height: 0;
		opacity: 0;
	}
`;

export const spin = keyframes`
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
`;

export const pulse = keyframes`
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0.5;
	}
	100% {
		opacity: 1;
	}
`;

export const scaleIn = keyframes`
	from {
		transform: scale(0.95);
		opacity: 0;
	}
	to {
		transform: scale(1);
		opacity: 1;
	}
`;

export const bounce = keyframes`
	0%, 100% {
		transform: scaleY(1);
	}
	50% {
		transform: scaleY(1.45);
	}
`;
